import { flow } from 'mobx-state-tree';
import { LoadableStatus } from '../../../mobx-utils';

export const fetchWeatherInformation = flow(function* (self, locations, lang) {
  self.status = LoadableStatus.init;

  const response = yield fetch(`/api/weather/forecast`, {
    method: 'POST',
    body: JSON.stringify({
      locations: locations,
      lng: lang,
    }),
    headers: {
      'Content-Type': 'application/json',
      accept: '*/*',
    },
    credentials: 'include',
  });

  const data = yield response.json();
  self.data = data;
  self.status = LoadableStatus.done;
});
